import React, { useEffect, useState } from 'react'
import { faCheck, faFileAlt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import Blocos from './components/Blocos';
import Stepper from 'components/Stepper/Stepper';

//Helpers
import { objCampo } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from 'helpers/message';
import Questoes from './components/Questoes';
import Documentos from './components/Documentos';
import FichaFormularioPGRSContainer from './components/FichaFormularioPGRSContainer';

//API
import pgrs_api from '../../../api/pgrs_api';
import { useAuth } from 'context/auth';
import Identificacao from './components/Identificacao';



function initialStateFormularioPGRS() {
  return {
    identificacao: "",
    tbFormularioPGRSModalidades: [],
    tbFormularioPGRSBlocos: [],
    tbFormularioPGRSDocumentos: []
  }
}

export default function NovoFormularioPGRS({ formularioPGRS = null, btnVoltar }) {
  const { setLoading } = useAuth();

  //Estado para criar/editar formulario
  const [formularioPGRSNovo, setFormularioPGRSNovo] = useState(formularioPGRS ? formularioPGRS : initialStateFormularioPGRS());

  //Estado de controle das opções de modalidades
  const [optionsModalidades, setOptionsModalidades] = useState([]);

  //Estado que faz o controle do passo ativo do stepper
  const [activeStep, setActiveStep] = useState(1);

  function validarIdentificacao() {
    if (!(!!formularioPGRSNovo?.identificacao)) {
      showMessage("Aviso", "Preencher o campo de identificação do formulário.", "warning", null);
      return ["Preencher o campo de identificação do formulário."];
    }

    if (formularioPGRSNovo?.tbFormularioPGRSModalidades.length == 0) {
      showMessage("Aviso", "Selecione pelo menos uma modalidade para formulário.", "warning", null);
      return ["Selecione pelo menos uma modalidade para formulário."];
    }

    return null
  }

  function validarBlocos() {
    if (formularioPGRSNovo.tbFormularioPGRSBlocos.length == 0) {
      showMessage("Aviso", "Informe pelo menos um bloco para continuar.", "warning", null);
      return ["Informe pelo menos um bloco para continuar."];
    }
    return null
  }

  function validarBlocosQuestoes() {
    if (formularioPGRSNovo?.tbFormularioPGRSBlocos?.some(questao => questao.tbFormularioPGRSBlocoQuestoes.length === 0)) {
      showMessage("Aviso", "Todos os blocos devem ter questões associadas!", "warning", null);
      return ["Todos os blocos devem ter questões associadas!"];
    }
    return null;
  }

  const steps = [
    { text: "Identificação", icon: faFileAlt, validateStep: validarIdentificacao },
    { text: "Blocos", icon: faFileAlt, validateStep: validarBlocos },
    { text: "Questões", icon: faPencilAlt, validateStep: validarBlocosQuestoes },
    { text: "Documentos", icon: faFileAlt },
    { text: "Finalizar", icon: faCheck },
  ];

  //Função que retorna o valor do passo ativo na tela
  const getStepContainer = (step) => {
    switch (step) {
      case 1:
        return <Identificacao
          formulario={formularioPGRSNovo}
          setFormulario={setFormularioPGRSNovo}
          optionsModalidades={optionsModalidades}
        />
      case 2:
        return <Blocos
          formulario={formularioPGRSNovo}
          setFormulario={setFormularioPGRSNovo}
        />
      case 3:
        return <Questoes
          formulario={formularioPGRSNovo}
          setFormulario={setFormularioPGRSNovo}
        />
      case 4:
        return <Documentos
          formulario={formularioPGRSNovo}
          setFormulario={setFormularioPGRSNovo}
        />
      case 5:
        return <FichaFormularioPGRSContainer
          formulario={formularioPGRSNovo}
        />
    }
  }

  function onSubmit() {
    const _formulario = { ...formularioPGRSNovo };

    _formulario.tbFormularioPGRSBlocos = _formulario.tbFormularioPGRSBlocos.map(bloco => {
      bloco.tbFormularioPGRSBlocoQuestoes.map(value => {
        if (value.tipoValor === "Lista") {
          value.tbFormularioPGRSBlocoQuestaoOpcoes = value.tbFormularioPGRSBlocoQuestaoOpcoes.map(option => {
            const _opcao = { valor: option.value };
            if (option.id)
              _opcao.id = option.id;

            return _opcao
          })
        }
        return value;
      });
      return bloco;
    });

    _formulario.tbFormularioPGRSModalidades = _formulario.tbFormularioPGRSModalidades.map(modalidade => {
      if (!modalidade?.tbTipoColeta_Id)
        modalidade.tbTipoColeta_Id = modalidade.value;
      return modalidade
    });

    setLoading(true)
    if (_formulario?.id) {
      pgrs_api.Update(_formulario)
        .then(response => {
          showMessage("Sucesso!", "Formulário atualizado com sucesso!", "success", btnVoltar);
        }).catch(e => {
          showMessage("Aviso!", e.message, "error", null);
        }).finally(() => setLoading(false));
    } else {
      pgrs_api.Insert(_formulario)
        .then(response => {
          showMessage("Sucesso!", "Formulário criado com sucesso!", "success", btnVoltar);
        }).catch(e => {
          showMessage("Aviso!", e.message, "error", null);
        }).finally(() => setLoading(false));
    }
  }

  function loadModalidadesFormulariosPGRS() {
    pgrs_api.GetListModalidadesFormularioPGRS(formularioPGRSNovo?.id ?? "").then(response => {
      response.data = response.data.map(value => {
        value.value = value.id;
        value.label = value.descricao;
        
        delete value.id;

        return value;
      })
      setOptionsModalidades(response.data);
    }).catch(e => {
      showMessage("Aviso", e.message, "error", null);
    })
  }
  useEffect(() => {
    loadModalidadesFormulariosPGRS();
  }, [formularioPGRSNovo])

  return (
    <MainCard btnVoltar={btnVoltar}>
      <Stepper
        steps={steps}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        onSubmit={onSubmit}
      >
        {getStepContainer(activeStep)}
      </Stepper>
    </MainCard>
  )
}
